import React, {useState, useEffect} from "react";
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import PatientUpdateForm from "./PatientUpdateForm";
import { SIREN_CONFIG } from 'config.js';
import {useSelector} from 'react-redux';


const PatientUpdate = (props) => {

  const {className, match, history, ...rest } = props;
  const classes = useStyles();

  const [patientInfo, setPatientInfo] = useState(null);
  const facility_id = useSelector((store) => store.user.facility_id);


  const loadData = (patientId) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/patient/patientInfo?facility_id=${facility_id}&patientId=${patientId}`;

    fetch(url)
    .then(res => res.json())
    .then(snapshot => {

      if (snapshot.resultData){
        var patient = {
          patientId: snapshot.resultData.patientId,
          patientName: snapshot.resultData.patientName,
          patientRoomId: snapshot.resultData.patientRoomId,
          patientRoomName: snapshot.resultData.patientRoomName,
          patientTelNo: snapshot.resultData.patientTelNo,
          patientPostCode: snapshot.resultData.patientPostCode,
          patientAddr1: snapshot.resultData.patientAddr1,
          patientAddr2: snapshot.resultData.patientAddr2,
          protector1_name: snapshot.resultData.protector1_name,
          protector1_tel_no: snapshot.resultData.protector1_tel_no,
          caregiver1_Id: snapshot.resultData.caregiver1_Id,
        };

        setPatientInfo(patient);
      }
    }
    );
  }


  useEffect( () => {
    loadData(match.params.patientId);
  }, []);


  return (
    <div className={classes.root}>
      <div className={classes.content}>
        { patientInfo && <PatientUpdateForm patientInfo={patientInfo} history={history} /> }
      </div>
    </div>
  );
};


PatientUpdate.propTypes = {
  history: PropTypes.object
};

export default PatientUpdate;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));
